import Vue from "vue";

const mutations = {
  LOCATIONS_UPDATED(state, wolves) {
    console.log("refreshed", wolves);
    state.locations = wolves;
  }
};

const actions = {
  refresh(context) {
    Vue.axios
      .get("/api/wolf/locations", {
        params: {
          optedIn: context.rootState.player.optedIn
        }
      })
      .then(response => {
        context.commit("LOCATIONS_UPDATED", response.data);
      });
  }
};

export default {
  namespaced: true,
  state: {
    locations: []
  },
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/wolves.js